import {getAuthToken} from "../Helpers";
import axios from 'axios';

const BASE_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

delete axios.defaults.headers.common["X-Requested-With"];
export const requestOptions = (apiPath, extendedOptions = {}) => ({
  url: `${BASE_API_URL.replace(/\/$/, '')}/${apiPath}`,
  method: 'GET',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'x-auth-token': getAuthToken(),
  },
  ...extendedOptions,
});
